'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _neptune = require('./neptune');

var _neptune2 = _interopRequireDefault(_neptune);

var _n2 = require('./_n');

var _n3 = _interopRequireDefault(_n2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_neptune2.default.debug = {
  levels: [],
  init: function init() {
    if (_n3.default.exists('[neptune-debug]')) {
      _neptune2.default.debug.levels = _n3.default.qs('[neptune-debug]').getAttribute('neptune-debug').split(',').map(function (l) {
        return l.trim();
      });
    }
  },
  info: function info(subject, data, msg) {
    _neptune2.default.debug.log('info', subject, data, msg);
  },
  warn: function warn(subject, data, msg) {
    _neptune2.default.debug.log('warn', subject, data, msg);
  },
  error: function error(subject, data, msg) {
    _neptune2.default.debug.log('error', subject, data, msg);
  },
  log: function log(type, subject, data, message) {

    var log = false;

    if (!!data.el) {
      _n3.default.qsa('[neptune-debug]').forEach(function (debugEl) {
        if (debugEl.getAttribute('neptune-debug').includes(type) && (data.el == window || debugEl == data.el || debugEl.contains(data.el))) {
          log = true;
        }
      });
    } else {
      log = true;
      // may want to remove this at some point here soon
    }

    if (!log) return false;

    message = message || '';
    type = type || 'info';
    data = data || {};
    subject = subject || '';

    if (!!!_neptune2.default.debug.levels || !_neptune2.default.debug.levels.includes(type)) return false;

    var badgestyles = {
      'info': 'color: white; background-color: blue; border-radius: 0 3px 3px 0;font-size:9px;padding:2px;',
      'warn': 'color: white; background-color: #ffbc00; border-radius: 0 3px 3px 0;font-size:9px;padding:2px;',
      'error': 'color: white; background-color: red; border-radius: 0 3px 3px 0;font-size:9px;padding:2px;'
    };
    console.log('%c Neptune %c ' + subject + ' ', 'color: blue;background:white;font-style:italic;border-radius: 3px 0 0 3px;font-size:9px;padding:2px;', badgestyles[type], message, data);
  }
};

window.Neptune = _neptune2.default;

exports.default = _neptune2.default.debug;